import { Instance } from 'mobx-state-tree';
import { ScheduleActionMetadataDtoModelBase } from './ScheduleActionMetadataDtoModel.base';

/* The TypeScript type of an instance of ScheduleActionMetadataDtoModel */
export interface ScheduleActionMetadataDtoModelType extends Instance<typeof ScheduleActionMetadataDtoModel.Type> {}

/* A graphql query fragment builders for ScheduleActionMetadataDtoModel */
export { selectFromScheduleActionMetadataDto, scheduleActionMetadataDtoModelPrimitives, ScheduleActionMetadataDtoModelSelector } from './ScheduleActionMetadataDtoModel.base';

/**
 * ScheduleActionMetadataDtoModel
 */
export const ScheduleActionMetadataDtoModel = ScheduleActionMetadataDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
